import "@fontsource/inter";
import "./src/styles/global.css";

import React from "react";

export const onClientEntry = () => {
  document.documentElement.lang = "en";
};
